import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-default',
  template: require('./default.component.html')
})
export class DefaultComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/default/default.component.ts